import { useQuery, useInfiniteQuery } from '@tanstack/react-query'
import { useCallback, useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'
import SharedTable from '../benefitPlan/SharedTable';
import debounce from 'lodash.debounce';
import Select from 'react-select';
import { fetchGetDocuments, fetchOpensearchGetAggs } from '../../utils/apiUtils.js';

const OpensearchKnowledgebase = () => {

    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState()
    const [selectedClientId, setSelectedClientId] = useState(null)
    const [selectedPlanId, setSelectedPlanId] = useState(null)

    const { ref, inView } = useInView()
    const SIZE = 10

    const { data: clientOptions } = useQuery({
        queryKey: ['getAggs', 'clients'],
        queryFn: async () => {

            return await fetchOpensearchGetAggs({
                index: 'knowledge-base',
                field: 'metadata.clientId.keyword',
                size: 100
            })
        },
        select: (data) => {
            return data.aggregations['metadata.clientId.keyword']?.buckets.map(bucket => ({
                label: `${bucket.key} (${bucket.doc_count})`,
                value: bucket.key
            }))
        }
    })

    const { data: planOptions } = useQuery({
        queryKey: ['getAggs', selectedClientId],
        queryFn: async () => {
            return await fetchOpensearchGetAggs({
                index: 'knowledge-base',
                field: 'metadata.planId.keyword',
                query: {
                    "term": {
                        "metadata.clientId.keyword": selectedClientId.value
                    }
                }
            })
        },
        select: (data) => {
            return data.aggregations['metadata.planId.keyword']?.buckets.map(bucket => ({
                label: `${bucket.key} (${bucket.doc_count})`,
                value: bucket.key
            }))
        },
        enabled: !!selectedClientId
    })

    const queryKey = ['fetchKnowledgebaseDocuments', decouncedSearchValue, selectedClientId, selectedPlanId];

    const {
        data,
        error,
        isError,
        fetchNextPage,
        hasNextPage,
        isLoading,
        isFetching,
        isFetchingNextPage,
        status,

    } = useInfiniteQuery(
        {
            queryKey,
            queryFn: async ({ pageParam }) => {
                let params = pageParam || {}

                let query = {
                    "match_all": {}
                };

                if (decouncedSearchValue) {
                    query = {
                        bool: {
                            must: [
                                {
                                    match_phrase: {
                                        text: {
                                            query: decouncedSearchValue,
                                            //    slop: 0
                                        }
                                    }
                                }
                            ]
                        }
                    }
                }
                if (selectedClientId) {
                    if (query.bool) {
                        query.bool.must.push({
                            term: {
                                'metadata.clientId.keyword': selectedClientId.value
                            }
                        })
                    } else {
                        query = {
                            bool: {
                                must: [
                                    {
                                        term: {
                                            'metadata.clientId.keyword': selectedClientId.value
                                        }
                                    }
                                ]
                            }
                        }
                    }


                    if (selectedPlanId) {
                        query.bool.must.push({
                            term: {
                                'metadata.planId.keyword': selectedPlanId.value
                            }
                        })
                    }
                }


                let body = {
                    //index: 'knowledge-base',
                    index: 'hrp-guide',
                    query,
                    size: SIZE,
                    track_total_hits: true,
                    // "sort": [
                    //     {
                    //         "metadata.uniqueId": {
                    //             "order": "asc"
                    //         }
                    //     }
                    // ]
                }
                if (pageParam.searchAfter) {
                    body.search_after = pageParam.searchAfter
                }
                return fetchGetDocuments(body)

            },

            initialPageParam: 0,
            getNextPageParam: (lastPage, pages) => {
                //   console.log({ lastPage })
                const lastItem = lastPage.hits?.hits.at(-1)
                if (!lastItem || (lastPage.hits?.hits.length < SIZE)) return undefined
                return { searchAfter: lastItem.sort }
            },
        }
    )

    useEffect(() => {
        if (inView) {
            fetchNextPage()
        }
    }, [inView])

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    const columns = ['text',
        // 'metadata.clientId', 'metadata.planId', 
        'metadata.page_number', 'metadata.filename', 'metadata.types']
    // console.log(data)
    const results = data?.pages?.map(page => page.hits?.hits)?.flat();
    const total = data?.pages?.[0]?.hits?.total?.value

    return (
        <div className={'container '} style={{ padding: '1rem' }}>
            <p className='title'>OpenSearch {total && `Total: (${total})`}</p>
            <p className="sub-title">Explore data</p>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>

                    <Select
                        name={'Client'}
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        placeholder={'Filter by Client'}
                        options={clientOptions}
                        value={selectedClientId}
                        onChange={(option) => { setSelectedPlanId(null); setSelectedClientId(option) }}
                    />


                    {selectedClientId && <Select
                        name={'Plan'}
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        placeholder={'Filter by Plan'}
                        options={planOptions}
                        value={selectedPlanId}
                        onChange={(option) => { setSelectedPlanId(option); }}
                    />}

                    <input
                        style={{ fontSize: '1rem', minWidth: '250px', margin: ' 0rem', padding: '1rem', borderRadius: '.4rem', border: '1px solid var(--lighterGrey)', outline: 'none' }}
                        type="text"
                        id={'search'}
                        placeholder="search..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />

                </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0rem 1rem 1rem 0rem', }}>
                <p style={{ cursor: 'pointer', color: 'var(--red)' }}
                    onClick={() => {
                        setSelectedClientId(null)
                        setSelectedPlanId(null)
                        setSearchValue('')
                        setDecouncedSearchValue('')

                    }}
                >Clear filters</p>
            </div>
            {isError && <p className="danger">{error?.message}</p>}
            {
                status === 'loading' ? (
                    <p>Loading...</p>
                ) : status === 'error' ? (
                    <span className='danger'>Error: {error.message}</span>
                ) : (
                    <>
                        <SharedTable
                            type={'knowledgebase'}
                            columns={columns}
                            items={results?.map(hit => ({ _id: hit?._id, ...hit?._source }))}
                            activeDraftId={null}
                            hasNextPage={hasNextPage}
                            isLoading={isLoading}
                            isFetchingNextPage={isFetchingNextPage}
                            fetchNextPage={fetchNextPage}
                            isFetching={isFetching}
                            searchText={decouncedSearchValue}
                            ref={ref}
                        />
                    </>
                )
            }

        </div>
    )
}

export default OpensearchKnowledgebase